import { Action } from '@ngrx/store';
import { Alerts } from '../../../shared/models/b2b/alerts';

export enum CheckoutActionTypes {
    DO_SET_ALERTS_SHOWED = '[Checkout] Set Alerts Showed'
}

// Alerts Showed
export class DoSetAlertsShowed implements Action {
    readonly type = CheckoutActionTypes.DO_SET_ALERTS_SHOWED;

    constructor(public payload: { alertsShowed: Alerts }) {}
}

export type CheckoutActions = DoSetAlertsShowed;
